import { createFileRoute } from '@tanstack/react-router'

import { QaRunPage } from '@/components/qa/qa-run-page'
import { RETURN_SHAPE } from '@/lib/return-to'
import { readSearch } from '@/lib/search-params'

export const Route = createFileRoute('/_app/qa/$runId')({
  validateSearch: (search: Record<string, unknown>) => readSearch(RETURN_SHAPE, search),
  component: QaRunRoutePage,
})

function QaRunRoutePage() {
  const { runId } = Route.useParams()
  return <QaRunPage key={runId} runId={runId} />
}
